import type { MultiBrandConfig } from './types';

// Website 03 — Airport Fast Lane storefront. Working brand: SkyLane.
// Premium "land connected" positioning for frequent/business flyers; clean
// sky-blue/navy boarding-pass aesthetic (skyline-day / skyline-night palettes).
// Name/domain are PROVISIONAL.
//
// DOMAIN NOTE: points at esimsupra.com for now because every storefront shares
// ONE backend (functions/ + billing worker + D1). Before SkyLane is deployed as
// its own indexed property it MUST get its own canonical domain + contact email
// to avoid cross-brand duplicate-content / canonical conflicts (risk R14).
// Until then it is build-selectable for preview only (BRAND_ID=airport-fast-lane).
export const skylane: MultiBrandConfig = {
  id: 'airport-fast-lane',
  status: 'provisional',
  siteType: 'storefront',
  positioning:
    'Premium airport "land connected" storefront for frequent and business flyers who value speed, certainty, and arrival readiness over the lowest price.',
  theme: {
    mode: 'light', // clean white / sky-blue, light-first
    defaultDark: 'skyline-night',
    defaultLight: 'skyline-day',
  },
  checkoutEnabled: true,
  // Premium airport brand: emphasize certainty/arrival-readiness over price. Presentation only.
  pricingDisplayMode: 'airport-premium',
  legacy: {
    brand: {
      name: 'SkyLane',
      displayName: 'SkyLane',
      tagline: 'Land Connected — Travel eSIM Ready Before Arrival',
      description:
        'Premium travel eSIMs for frequent flyers. Get set up before you board, then land connected in 180+ countries — no SIM line, no roaming surprises.',
      logo: '/images/assets/logo.svg',
      logoAlt: 'SkyLane Logo',
    },
    contact: {
      // Shared support inbox for now (shared backend). Swap to a brand inbox at launch.
      // TODO(brand-email): planned dedicated inbox `help@esimarrival.com` (TBD) before indexed launch (R14).
      email: 'contact@esimsupra.com',
      phone: '',
      phoneFormatted: '',
      whatsapp: '',
      address: 'Available Worldwide',
      supportHours: '24/7 Support',
    },
    website: {
      // PROVISIONAL — see domain note above. Own domain required before launch.
      url: 'https://esimsupra.com',
      domain: 'esimsupra.com',
    },
    social: {
      facebook: '',
      twitter: '',
      instagram: '',
      youtube: '',
      telegram: '',
    },
    resources: {
      compatibilityUrl: '#',
      compatibilityLabel: 'Check Device Compatibility',
    },
    legal: {
      copyrightYear: new Date().getFullYear().toString(),
      copyrightText: `© ${new Date().getFullYear()} SkyLane. All rights reserved.`,
    },
    features: {
      count180Countries: '180+ Countries',
      uptimePerformance: 'Reliable 4G/5G',
      support247: '24/7 Support',
    },
    ui: {
      theme_palette_selector: true,
    },
  },
  tech: {
    analytics: {
      gtmId: 'TBD — provision per-brand GTM container ID in Google Tag Manager',
      ga4Id: 'TBD — provision per-brand GA4 measurement ID in Google Analytics',
      metaPixelId: 'TBD — provision per-brand Pixel ID in Meta Events Manager',
      googleAdsConversionId: 'TBD — provision per-brand conversion ID in Google Ads',
      googleAdsPurchaseLabel: 'TBD — provision per-brand purchase conversion label in Google Ads',
    },
    trustpilot: {
      businessUnitId: 'TBD — create Trustpilot Business Unit for esimarrival.com',
      locale: 'en-US',
    },
    stripe: {
      statementDescriptorSuffix: 'SKYLANE',
      accountId: 'TBD — create Stripe Connect account or use statement_descriptor_suffix on shared account',
    },
    canonical: {
      domain: 'esimarrival.com',
      url: 'https://esimarrival.com',
      organizationLegalName: 'TBD — register legal entity for SkyLane',
    },
    llms: {
      tagline: 'Land Connected — Travel eSIM Ready Before Arrival',
      audience: 'Frequent and business flyers who value arrival readiness over lowest price.',
    },
  },
};

export default skylane;
